import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './tooltipContent.css';

interface ITooltipContentProps {
  description: string;
  onVisible(): void;
}

export const TooltipContent = ({ description, onVisible }: ITooltipContentProps) => {
  React.useEffect(() => {
    const id = setTimeout(onVisible, 3000);

    return () => clearTimeout(id);
  }, []);

  return (
    <div className={styles['tooltip']}>
      <InlineText2>{description}</InlineText2>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';
